<script>
	export let text = "";
	export let bold = false;
	export let italic = false;
	export let full_width = false;

	$: widthClass = full_width ? '' : 'w-1/4';
	$: fontWeight = bold ? 'font-bold' : '';
	$: fontStyle = italic ? 'italic' : '';
</script>

<span
	class={`text-left text-[--app-text-color-darker] font-[Open Sans] min-w-[25%] ${widthClass} ${fontWeight} ${fontStyle}`}
>
	{text}
</span>
